import { render, staticRenderFns } from "./IrisTextfieldContainer.vue?vue&type=template&id=20858ac5&"
import script from "./IrisTextfieldContainer.vue?vue&type=script&lang=ts&"
export * from "./IrisTextfieldContainer.vue?vue&type=script&lang=ts&"
import style0 from "./IrisTextfieldContainer.vue?vue&type=style&index=0&id=20858ac5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports